const TYPES = ({
  loadingFormSearch: 'LOADING_SEARCH_ARTICLE_FORM_TOGGLE',
  searchSuccess: 'SEARCH_ARTICLE_SUCCESS',
  searchError: 'SEARCH_ARTICLE_LIST_ERROR'
});

export default TYPES;
